import {emptyGuid, isGuidEmpty} from "../../../../Utilities/commonUtilities";

export const ownCatalogItemModel = ({
                                        catalogNumber,
                                        cost,
                                        id = emptyGuid,
                                        title,
                                        objectType,
                                        description,
                                        orderLimit,
                                        fileLink,
                                        keywords,
                                        productImageUrl,
                                        availabilityStatus,
                                        isForInternalUse,
                                        whatsNewStartDate,
                                        whatsNewEndDate,
                                        manufacturerId,
                                        vendorId,
                                    }: Record<string, any> = {}) => ({
    catalogNumber,
    cost,
    id,
    title,
    objectType,
    description: description || '',
    orderLimit,
    fileLink: fileLink || '',
    keywords: keywords || '',
    productImageUrl: productImageUrl || null,
    availabilityStatus: isForInternalUse !== undefined
        ? (isForInternalUse === true || isForInternalUse === "true" ? 2 : 1)
        : (availabilityStatus ?? 1),
    isForInternalUse: isForInternalUse !== undefined
        ? (isForInternalUse === true || isForInternalUse === "true")
        : availabilityStatus === 2,
    whatsNewStartDate,
    whatsNewEndDate,
    manufacturerId: isGuidEmpty(manufacturerId) ? null : manufacturerId,
    vendorId: vendorId || null,
    removeImage: false,
});


export const emptyOwnCatalogItemModel = ownCatalogItemModel();
